import { action } from 'typesafe-actions';
import { ISite, ISiteBalance } from '../../types';
import { Site } from './types';

export const getSiteRequest = (siteId: string) => action(Site.GET_SITE_REQUEST, { siteId });
export const getSiteSuccess = (response: ISite) => action(Site.GET_SITE_SUCCESS, response);
export const getSiteError = (error: any) => action(Site.GET_SITE_FAIL, error);

export const getSiteBalanceRequest = (siteId: string) => action(Site.GET_SITE_BALANCE_REQUEST, { siteId });
export const getSiteBalanceSuccess = (response: ISiteBalance) => action(Site.GET_SITE_BALANCE_SUCCESS, response);
export const getSiteBalanceError = (error: any) => action(Site.GET_SITE_BALANCE_FAIL, error);

export const clearSite = () => action(Site.CLEAR_SITE);
